import { Component, Inject, OnInit } from '@angular/core';
import { DragToTopDirective } from '@brunsker/libs/portal-do-vendedor/ui/drag-to-top';
import { Title } from '@angular/platform-browser';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';

@Component({
  selector: 'brunsker-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss',
    '../libs/themes/portal-do-vendedor/theme.scss',
  ],
  hostDirectives: [DragToTopDirective]
})
export class AppComponent implements OnInit {
  title = 'Bs Vendas';

  constructor(
    private titleService: Title,
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment) {}

  ngOnInit(): void
  {
    this.titleService.setTitle(this.environment.name);
  }
}
